module.exports = __webpack_public_path__ + "img/warnings-10.01fd9638.png";